module.exports = __webpack_public_path__ + "media/images/homepage/pause-icon-d25bee7fafd13e8179080f91d2c8432a.svg";